import { styled } from 'styled-components'
import { Accordion as BSAccordion } from 'react-bootstrap'

export const TextContainer = styled.div`
  flex: 1;
  min-width: 200px;
  font-size: clamp(1rem, 4vw, 1.5rem);
  margin-right: auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem;
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-left: auto;

  @container (max-width: 450px) {
    width: 100%;
    justify-content: center;
    margin-top: 0.5rem;
  }
`

export const AudioRecorderWrapper = styled.div`
  container-type: inline-size;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: var(--primary);
  color: var(--bs-white);
  border-radius: 2rem;

  .btn {
    box-shadow: none !important;
    background: var(--bs-white) !important;
    color: var(--primary) !important;
    margin: 0 !important;
    padding: 0 !important;
    width: 3rem !important;
    height: 3rem !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
    border-radius: 50% !important;
    border-color: var(--primary);
  }
`

export const Accordion = styled(BSAccordion)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const AccordionCollapse = styled(BSAccordion.Collapse)`
  /* center video */
  &:has(video) {
    margin: 0 auto;
  }
`
